module.exports = __webpack_public_path__ + "static/mongodb-bca7dfdc5274e4cf0eb951adaa1e4993.png";